import { render, staticRenderFns } from "./ChangeDistributorModal.vue?vue&type=template&id=ed396498&scoped=true&"
import script from "./ChangeDistributorModal.vue?vue&type=script&lang=js&"
export * from "./ChangeDistributorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed396498",
  null
  
)

export default component.exports